'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ sivu',
  jump_to: 'Mene',
  page: '',

  // Pagination.jsx
  prev_page: 'Edellinen sivu',
  next_page: 'Seuraava sivu',
  prev_5: 'Edelliset 5 sivua',
  next_5: 'Seuraavat 5 sivua',
  prev_3: 'Edelliset 3 sivua',
  next_3: 'Seuraavat 3 sivua'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/.1.9.8@rc-pagination/lib/locale/fi_FI.js
// module id = 910
// module chunks = 0